import React from 'react';
import './change-password.scss';
import AuthenticateAPI from '../../apis/authenticate'
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component';
import Header from '../common/header/header-component';
import { ImageConstants, Constants } from '../../constants/constants';
import { getImageSource } from '../../utility/image-source'
import Path from '../routes/routes-path';
import SessionCache from '../routes/session-cache';

class ChangePassword extends React.Component {
    state = {
        loading: "",
        isSubmit: false,
        isInvalidEmail: false,
        isInvalidPassword: false,
        isInvalidNewPassword: false,
        isPasswordMisMatch: false
    }

    onChangeHandler = (event, key) => {
        this.setState({ [key]: event.target.value, isInvalidNewPassword: false });
    }

    changePassword = () => {

        if (this.state.isSubmit) return

        if (!this.validatePayload()) {
            return;
        }


        if (!this.validateNewPassword()) return

        const loadingIntervel = setInterval(() => {
            if (this.state.loading.length === 3) {
                this.setState({ loading: `.` })
            } else {

                this.setState({ loading: `${this.state.loading}.` })
            }
        }, 500)


        this.setState({ isSubmit: true });
        let payload = {
            password: this.state.newPassword
        };

        AuthenticateAPI.changePassword(payload).then((userDetails) => {

            clearInterval(loadingIntervel)
            this.setState({ isSubmit: false, loading: "", errMessage: "" })
            this.showToaster("success", "New password updated successfully");
            let user = SessionCache.getUser()
            SessionCache.setUser({ ...user, passwordUpdated: true })
            setTimeout(() => {
                this.props.history.push(Path.DASHBOARD)
            }, 1000)

        }).catch((err) => {
            clearInterval(loadingIntervel)

            this.setState({ isSubmit: false, loading: "" })

            if (err.response && err.response.status === 400) {

                let errMessage = ""
                if (err.response.data && err.response.data.message) {
                    errMessage = err.response.data.message
                }

                this.setState({ errMessage })
                this.showToaster("error", err.response.data.message);

            } else {
                this.showToaster("error", 'Something went wrong');
            }

        })

    }

    validatePayload() {

        if (!this.state.newPassword) {
            this.setState({ isInvalidNewPassword: true, errMessage: "" })
            return false
        }

        if (this.state.newPassword.length < 6) {
            this.setState({ isInvalidNewPassword: true, errMessage: "Password must be at least 6 characters" })
            return false
        }

        if (!this.state.confirmPassword) {
            this.setState({ isPasswordMisMatch: true })
            return false
        }

        if (!this.validateNewPassword()) return false

        this.setState({ isPasswordMisMatch: false, isInvalidNewPassword: false, isInvalidEmail: false, isInvalidPassword: false })
        return true
    }

    validateNewPassword = () => {
        if (this.state.newPassword !== this.state.confirmPassword) {
            this.setState({ isPasswordMisMatch: true })
            return false
        } else {
            this.setState({ isPasswordMisMatch: false })
            return true
        }
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 3000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    render() {
        return (
            <div>
                <Header from={'VERIFY_SCREEN'}></Header>
                <div className="change-password">
                    <div className="text-right">
                        <img src={getImageSource(ImageConstants.ONBOARD_TOP_RIGHT)} className='vector-image-top-right' />
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="text-header">
                                <strong>Update Password </strong>
                            </div>

                            <div className="sign-up center-box pt-2">
                                <div className='cw-card'>
                                    <div className='cw-card-body'>

                                        <div className='row'>
                                            <div className='col'>
                                                <label className='cw-input-label'>New Password <span className='star'>*</span><span> (minimum 6 characters)</span></label>
                                                <input className={`cw-input ${this.state.isInvalidNewPassword ? 'invalid' : ''}`}
                                                    placeholder='Enter Your New Password'
                                                    onChange={(e) => this.onChangeHandler(e, 'newPassword')} type='password'
                                                />
                                                {this.state.isInvalidNewPassword ? <span className='invalid-text'> {this.state.errMessage || "Please enter new password"}</span> : ''}
                                            </div>
                                        </div>

                                        <div className='row pt-4'>
                                            <div className='col'>
                                                <label className='cw-input-label'>Confirm Password <span className='star'>*</span></label>
                                                <input className={`cw-input ${this.state.isPasswordMisMatch ? 'invalid' : ''}`}
                                                    placeholder='Enter Your New Password Again'
                                                    onChange={(e) => this.onChangeHandler(e, 'confirmPassword')} type='password'
                                                    onBlur={this.validateNewPassword}
                                                />
                                                {this.state.isPasswordMisMatch ? <span className='invalid-text'>Password mismatch</span> : ''}
                                            </div>
                                        </div>

                                    </div>

                                    <div className='cw-card-footer' onClick={this.changePassword}>
                                        <span className='footer-text'>Submit {this.state.loading}</span>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className='col py-4'>
                            <img src={getImageSource(ImageConstants.FORGOT_PASSWORD)} className='profile-vector-img' />
                        </div>
                    </div>
                </div >
                {this.state.showToaster ? <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} /> : ""}
            </div >
        );
    }
}

export default ChangePassword;